import {Controller} from "@hotwired/stimulus"
import {patch} from "@rails/request.js";
import * as bootstrap from "bootstrap";

// Connects to data-controller="ticket-row"
export default class extends Controller {

  static values = {
    updateStateUrl: String,
    activeState: Boolean,
  }

  connect() {
    this.initializeDropdowns()
  }

  toggleTicketState() {
    patch(`${this.updateStateUrlValue}`, {
      contentType: "application/json",
      responseKind: "turbo-stream",
      body: {
        visible: !this.activeStateValue
      }
    });
  }

  initializeDropdowns() {
    // Initialize Bootstrap dropdowns with proper boundary configuration to escape overflow containers
    const dropdownElements = this.element.querySelectorAll('.dropdown-toggle[data-bs-toggle="dropdown"]');
    dropdownElements.forEach(toggle => {
      // Dispose existing dropdown instance if any
      const existingDropdown = bootstrap.Dropdown.getInstance(toggle);
      if (existingDropdown) {
        existingDropdown.dispose();
      }

      // Create new dropdown with fixed positioning strategy to escape overflow containers
      new bootstrap.Dropdown(toggle, {
        boundary: 'viewport',
        popperConfig: {
          strategy: 'fixed'
        }
      });
    });
  }
}
